






import React from 'react';
import Hero from '../../Components/Hero/Hero';
import MissionStatement from '../../Components/MissonStatement/MissionStatement';
import Sponsors from '../../Components/Sponsors/Sponsors';
import Features from '../../Components/ Features/Features';
import AboutUs from '../../Components/AboutUs/AboutUs';
import Donate from '../../Components/Donate/Donate';






const Home: React.FC = () => {




  return (
        <>

            <Hero />
            <Sponsors />
            <MissionStatement />
            <Features />
            <AboutUs />
            <Donate />





        </>



  );
};





export default Home;